import TestPackageModel from "@/models/lab/TestPackageModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * TestPackage collection
 */
export default class TestPackageCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return TestPackageModel;
  }

}
